import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { ThemeProvider } from 'next-themes'
import SecretApp from './secret/SecretApp'
import './secret/secret-index.css'

// Remove loading screen after React mounts
const removeLoadingScreen = () => {
  const loadingScreen = document.querySelector('.loading-screen')
  if (loadingScreen) {
    loadingScreen.style.opacity = '0'
    loadingScreen.style.transition = 'opacity 0.5s ease-out'
    setTimeout(() => {
      loadingScreen.remove()
    }, 500)
  }
}

// Environment check
if (!window.__SECRET_MODE__) {
  console.warn('SECRET mode not detected - redirecting to main site')
  window.location.href = 'https://tailtations.com'
}

// Initialize React app
ReactDOM.createRoot(document.getElementById('secret-root')!).render(
  <HelmetProvider>
    <BrowserRouter>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem={true}
        disableTransitionOnChange={true}
        storageKey="tailtations-theme"
      >
        <SecretApp />
      </ThemeProvider>
    </BrowserRouter>
  </HelmetProvider>,
)

// Remove loading screen after mount
setTimeout(removeLoadingScreen, 1000)

// Hot reload handling for development
if (import.meta.hot) {
  import.meta.hot.accept()
}